import { fetchData } from "./settings"
import { AnimeApiFormatList } from "./animeApi";

const fromAnimeApiResponseToInitialstate = apiResponse => {
    return AnimeApiFormatList(apiResponse?.data);
}
export default function serviceInitialState() {
    /* return fetch(`${API_INITIAL}`)
        .then(res => res.json())
        .then(fromAnimeApiResponseToInitialstate) */
    return fromAnimeApiResponseToInitialstate(fetchData);
}


